// Central content, brand + shared motion variants for the landing page.

export const BRAND = {
  name: "Innovate IT Solutions",
  short: "Innovate IT",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_ba152a9f-39ac-4b56-a296-c3d4680f5432/artifacts/7kd80sdh_WhatsApp%20Image%202026-07-16%20at%209.43.27%20PM.jpeg",
  tagline: "Software Studio × Industry Academy",
  contact: {
    email: "hr@innovateitsols.com",
    phone: "+91 8080956015",
    address: "Satyam Archade, near Ramwadi Metro Station, Pune - 411014",
  },
  socials: [
    { label: "LinkedIn", href: "#" },
    { label: "Instagram", href: "#" },
    { label: "GitHub", href: "#" },
    { label: "YouTube", href: "#" },
  ],
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Mission & Vision", href: "#manifesto" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Our Mission",
    body: "To engineer software that quietly outperforms and to shape engineers who quietly outclass. We treat every product build and every trainee as a single continuous craft — code that ships, careers that launch.",
  },
  {
    number: "02",
    title: "Our Vision",
    body: "A world where the distance between classroom and codebase disappears. Where India's next generation of builders learns on live problems, ships on real infrastructure, and enters the industry already fluent.",
  },
  {
    number: "03",
    title: "Our Discipline",
    body: "Fewer things, done exceptionally. Clean architecture over clever tricks. Mentors over marketing. Placements measured in offers, not photos. Products measured in retention, not launches.",
  },
];

export const SOFTWARE_SERVICES = [
  {
    tag: "01 / Build",
    title: "Web Development",
    body: "Bespoke web platforms — React, Next.js, FastAPI, Node. Product-grade architecture, sub-second interactions, painless deploys.",
  },
  {
    tag: "02 / Build",
    title: "App Development",
    body: "iOS, Android and cross-platform apps in React Native and Flutter. From MVP in weeks to production-grade rollouts.",
  },
  {
    tag: "03 / Think",
    title: "Business Analysis",
    body: "Discovery workshops, requirement engineering, process mapping. We translate business ambiguity into shippable specifications.",
  },
];

export const TRAINING_TRACKS = [
  { code: "T01", title: "Data Science", note: "Python · SQL · ML · Analytics" },
  { code: "T02", title: "AI / ML", note: "PyTorch · LLMs · MLOps" },
  { code: "T03", title: "Cloud Computing", note: "AWS · Azure · GCP · IaC" },
  { code: "T04", title: "Application Packaging", note: "MSIX · SCCM · Intune · App-V" },
  { code: "T05", title: "Full-Stack Web Development", note: "React · Node · Databases" },
  { code: "T06", title: "Business Analysis", note: "Agile · BRD · SQL · JIRA" },
];

export const TRAINING_PROMISES = [
  { k: "Hands-on training", v: "Not lectures. Live labs, whiteboards, PRs." },
  { k: "Live projects", v: "Real client briefs. Real repositories. Real stakes." },
  { k: "6-month internship", v: "Structured, paid, and mentored — inside our studio." },
  { k: "Interview support", v: "Mock loops with senior engineers. Weekly." },
  { k: "Placement support", v: "Dedicated hiring partners. Referrals until you land." },
];

export const MARQUEE_ITEMS = [
  "Innovate IT Solutions",
  "Software Development",
  "Industry Training",
  "Live Projects",
  "AI / ML",
  "Cloud",
  "Placement Support",
];

export const STATS = [
  { k: "150+", v: "Engineers trained" },
  { k: "94%", v: "Placement rate" },
  { k: "10+", v: "Products shipped" },
  { k: "6 mo.", v: "Paid internship" },
];
